import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { fromNewDateFormatToDDMMYYYYHHmmssSlash } from '../../Helpers/dateHelper';

export default function HeaderbarTimer(props) {
    const classes = useStyles();
    const [date, setDate] = useState(null);

    useEffect(() => {
        const timer = 
        setInterval(() => {
            setDate(fromNewDateFormatToDDMMYYYYHHmmssSlash(new Date()));
        }, 1000);

        return () => {            
            clearInterval(timer);
            setDate(null);
        }
    }, []);

    return <div className={classes.container}>
        {date}
    </div>
}

const useStyles = makeStyles({
    container: {
        fontSize: "11px",
        fontFamily: "Lato, sans-serif",
        color: "#8D8D8D",
        float: "left",

    }
});